module.exports = {
  onInput (input) {
    this.state = {
      title: input.title
    };
  }
};
